export const EVENT_ACTION_REDEEM_ACCOUNT_DROPDOWN_CLICK =
  'ROO_LOYALTY_REDEEM_ACCOUNT_DROPDOWN_CLICK';
